export const IconDropDownMenu = [{
	name: 'ClubHouse',
	icon: 'ClubHouse',
	tooltip: 'Club house',
	tool: 'icon',
	props: {
		iconName: 'ClubHouse',
		directionalIcon: 'DirectionalChevronRounded',
		renderTargets: ['course']
	}
}, {
	name: 'CartGarage',
	icon: 'CartGarage',
	tooltip: 'Cart garage',
	tool: 'icon',
	props: {
		iconName: 'CartGarage',
		directionalIcon: 'DirectionalChevronRounded',
		renderTargets: ['course']
	}
}, {
	name: 'Defibrillator',
	icon: 'Defibrillator',
	tooltip: 'Defibrillator',
	tool: 'icon',
	props: {
		iconName: 'Defibrillator',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'EVCharging',
	icon: 'EVCharging',
	tooltip: 'EV charging',
	tool: 'icon',
	props: {
		iconName: 'EVCharging',
		directionalIcon: 'DirectionalChevronRounded',
		renderTargets: ['course']
	}
}, {
	name: 'Kiosk',
	icon: 'Kiosk',
	tooltip: 'Kiosk',
	tool: 'icon',
	props: {
		iconName: 'Kiosk',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'LightningShelter',
	icon: 'LightningShelter',
	tooltip: 'Lightning shelter',
	tool: 'icon',
	props: {
		iconName: 'LightningShelter',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'NoAccess',
	icon: 'NoAccess',
	tooltip: 'No access',
	tool: 'icon',
	props: {
		iconName: 'NoAccess',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'NoCarts',
	icon: 'NoCarts',
	tooltip: 'No carts',
	tool: 'icon',
	props: {
		iconName: 'NoCarts',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'Parking',
	icon: 'Parking',
	tooltip: 'Parking',
	tool: 'icon',
	props: {
		iconName: 'Parking',
		directionalIcon: 'DirectionalChevronRounded',
		renderTargets: ['course']
	}
}, {
	name: 'Padel',
	icon: 'Padel',
	tooltip: 'Padel',
	tool: 'icon',
	props: {
		iconName: 'Padel',
		directionalIcon: 'DirectionalChevronRounded',
		renderTargets: ['course']
	}
}, {
	name: 'Shop',
	icon: 'Shop',
	tooltip: 'Shop',
	tool: 'icon',
	props: {
		iconName: 'Shop',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'Pro',
	icon: 'Pro',
	tooltip: 'Pro',
	tool: 'icon',
	props: {
		iconName: 'Pro',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'Simulator',
	icon: 'Simulator',
	tooltip: 'Simulator',
	tool: 'icon',
	props: {
		iconName: 'Simulator',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'Restaurant',
	icon: 'Restaurant',
	tooltip: 'Restaurant',
	tool: 'icon',
	props: {
		iconName: 'Restaurant',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'WC',
	icon: 'WC',
	tooltip: 'WC',
	tool: 'icon',
	props: {
		iconName: 'WC',
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'WaterTap',
	icon: 'WaterTap',
	tooltip: 'Water tap',
	tool: 'icon',
	props: {
		iconName: 'WaterTap',
		directionalIcon: 'DirectionalChevronRounded'
	}
}].sort((a, b) => a.tooltip.localeCompare(b.tooltip))

export const HoleIconDropDownMenu = [{
	name: 'Bell',
	icon: 'Bell',
	tooltip: 'Bell',
	tool: 'holeicon',
	props: {
		iconName: 'Bell',
		directional: false,
	}
}, {
	name: 'Cart',
	icon: 'Cart',
	tooltip: 'Cart',
	tool: 'holeicon',
	props: {
		iconName: 'Cart',
		directional: true,
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'DropZone',
	icon: 'DropZone',
	tooltip: 'Drop zone',
	tool: 'holeicon',
	props: {
		iconName: 'DropZone',
		directional: false,
	}
}, {
	name: 'NextTee',
	icon: 'NextTee',
	tooltip: 'Next tee',
	tool: 'holeicon',
	props: {
		iconName: 'NextTee',
		directional: true,
		directionalIcon: 'DirectionalChevronRounded'
	}
}, {
	name: 'Warning',
	icon: 'Warning',
	tooltip: 'Warning',
	tool: 'holeicon',
	props: {
		iconName: 'Warning',
		directional: false,
	}
}].sort((a, b) => a.tooltip.localeCompare(b.tooltip))

export const IconCollection = IconDropDownMenu